import { render, staticRenderFns } from "./settingEdit.vue?vue&type=template&id=3f6c25fa&scoped=true"
import script from "./settingEdit.vue?vue&type=script&lang=js"
export * from "./settingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c25fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f6c25fa')) {
      api.createRecord('3f6c25fa', component.options)
    } else {
      api.reload('3f6c25fa', component.options)
    }
    module.hot.accept("./settingEdit.vue?vue&type=template&id=3f6c25fa&scoped=true", function () {
      api.rerender('3f6c25fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplier/coupons/settingEdit.vue"
export default component.exports